import {
  LOADING_ARRAY,
  LIST_COMMUNITY_UNITS_REQUEST,
  LIST_COMMUNITY_UNITS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// communityId -> [unitIds, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_COMMUNITY_UNITS_REQUEST:
      return {
        ...state,
        [action.communityId]: state[action.communityId] || LOADING_ARRAY,
      }
    case LIST_COMMUNITY_UNITS_RESPONSE:
      return {
        ...state,
        [action.communityId]: (action.units || []).map((unit) => unit.id),
      }

    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
